/**
 * Factory to map a generic handleEvent(type,data) callback to the handlers
 * object expected by streamSSE.
 */
export function makeSSEHandlers(handleEvent) {
  return {
    pipeline_started: d => handleEvent('pipeline_started', d),
    step_start: d => handleEvent('step_start', d),
    new_message: d => handleEvent('new_message', d),
    cheatsheet: d => handleEvent('cheatsheet', d),
    cancelled: d => handleEvent('cancelled', d),
    heartbeat: d => handleEvent('heartbeat', d),
    pipeline_paused: d => handleEvent('pipeline_paused', d),
    pipeline_complete: d => handleEvent('pipeline_complete', d),
    pipeline_files: d => handleEvent('pipeline_files', d),
    error: d => handleEvent('error', d),
    // Monitor events
    monitor_started: d => handleEvent('monitor_started', d),
    monitor_decision: d => handleEvent('monitor_decision', d),
    monitor_complete: d => handleEvent('monitor_complete', d),
    monitor_aborted: d => handleEvent('monitor_aborted', d),
    monitor_error: d => handleEvent('monitor_error', d),
    monitor_step_complete: d => handleEvent('monitor_step_complete', d),
  };
}

export default makeSSEHandlers;
